import React from 'react'

const Section3 = () => {
  return (
    <div className=' w-full bg-richblack-700 font-mono font-semibold p-10'>
        <div className=' w-10/12 mx-auto flex md:flex-row flex-col items-center gap-5 md:gap-0 md:justify-around'>
            <div className=' text-center'>
                <h1 className='text-[30px] font-bold text-richblack-5'>5K</h1>
                <p className='font-semibold text-[16px] text-richblack-500'>Active Students</p>
            </div>
            <div className=' text-center'>
                <h1 className='text-[30px] font-bold text-richblack-5'>10+</h1>
                <p className='font-semibold text-[16px] text-richblack-500'>Mentors</p>
            </div>
            <div className=' text-center'>
                <h1 className='text-[30px] font-bold text-richblack-5'>200+</h1>
                <p className='font-semibold text-[16px] text-richblack-500'>Courses</p>
            </div>
            <div className=' text-center'>
                <h1 className='text-[30px] font-bold text-richblack-5'>50+</h1>
                <p className='font-semibold text-[16px] text-richblack-500'>Awards</p>
            </div>
        </div>
        
    </div>
  )
}

export default Section3